import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
  },
  subject: {
    fontWeight: theme.typography.fontWeightBold
  }
}));
